import { Box, Button, Chip, Typography } from "@mui/material";
import {Add, CheckBoxOutlineBlank, CheckBoxOutlined, ContentCopy, FilterAlt, KeyboardArrowDown, KeyboardArrowRight}
    from "@mui/icons-material";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid-pro";
import makeStyles from "@mui/styles/makeStyles";
import { createLink } from "../../utility/url";
import CopyClipboardButton from "../../utility/CopyClipboardButton";
import {selectModeData, selectProject} from "../../redux/selectors/editor";
import { Sheets } from "./GridView";
import { connect } from "react-redux";
import {useMemo, useCallback, useContext} from "react";
import { updateModeData } from "../../redux/slices/editor";
import { selectSheets } from "../../redux/selectors/firebase";
import { noGroup } from "./gridViewFilters";
import {ISheetModeData} from "../../redux/slices/editor";
import {FirebaseContext} from "../firebase/FirebaseProvider";

const useStyles = makeStyles(() => ({
    content: {
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
        display: "flex"
    },
    toolbar: {
        boxSizing: "border-box",
        display: "flex",
        flexGrow: 1,
        maxWidth: "100vw",
        justifyContent: "flex-start"
    }
}));

interface Props
{
    onClickAddColumn: () => void
    onClickToggleGroup: () => void
    modeData: ISheetModeData
    project: string
    updateModeData: (modeData: Partial<ISheetModeData>) => void
    sheets: Sheets
}

function SheetToolbar({ onClickAddColumn, sheets, onClickToggleGroup, project, modeData, updateModeData }: Props)
{
    const classes = useStyles();

    const { sheetId, expanded, groupedViewEnabled } = modeData;
    const { push } = useContext(FirebaseContext);
    const allCollapsed = useMemo(() =>
    {
        return Object.values(expanded ?? {}).every((expand) => expand === false);
    }, [expanded]);

    const sheet = sheetId && sheetId in sheets ? sheets[sheetId] : null;
    const activeFilters = useMemo(() => Object.keys(sheet?.filterModel?.items ?? {}).length, [sheet]);
    const isGrouped = sheet && sheet.group && sheet.group !== noGroup.id;
    const handleClickToggleExpandGroups = useCallback(() =>
    {
        const groupExpanded: { [id: string]: boolean } = {};
        Object.keys(expanded ?? {}).forEach((group) =>
        {
            groupExpanded[group] = allCollapsed;
        });

        updateModeData({ expanded: groupExpanded })
    }, [allCollapsed, expanded, updateModeData]);
    const handleDuplicateSheet = useCallback(() => {
        if (sheet) {
            push(`sheets/${project}`, {...sheet, name: `Copy of ${sheet.name}`}).catch(console.error);
        }
    }, [project, push, sheet]);

    return (
        <Box className={classes.content}>
            <GridToolbarContainer className={classes.toolbar}>
                <Button onClick={onClickAddColumn}>
                    <Add /><Typography variant="button" fontSize={"small"}>Add Column</Typography>
                </Button>
                {isGrouped && <Button onClick={onClickToggleGroup}>
                    {groupedViewEnabled ? <CheckBoxOutlined /> : <CheckBoxOutlineBlank />}
                    <Typography variant="button" fontSize={"small"}>Grouping</Typography>
                </Button>}
                {isGrouped && groupedViewEnabled && <Button onClick={handleClickToggleExpandGroups}>
                    {allCollapsed ? <KeyboardArrowRight fontSize={"small"} /> : <KeyboardArrowDown fontSize={"small"} />}
                    <Typography variant="button" fontSize={"small"}>{allCollapsed ? "Expand All" : "Collapse All"}</Typography>
                </Button>}
                {activeFilters > 0 && <Chip avatar={<FilterAlt />} label={`${activeFilters} Filters`}/>}
                <Box style={{ flexGrow: 1 }}/>
                <Button onClick={handleDuplicateSheet}>
                    <ContentCopy/><Typography variant="button" fontSize={"small"}>Duplicate Sheet</Typography>
                </Button>
                <CopyClipboardButton label={"Share Link"} value={createLink({ sheet: sheetId ?? "" })} />
                <GridToolbarExport />
            </GridToolbarContainer>
        </Box >
    );
}

const mapStateToProps = (store: never) => ({
    sheets: selectSheets(store) ?? {},
    modeData: selectModeData(store) ?? {} as ISheetModeData,
    project: selectProject(store)
});
export default connect(mapStateToProps, {
    updateModeData
})(SheetToolbar);